const variantClasses = {
  primary:
    "bg-brand-gold-soft text-brand-primary shadow-[0_12px_24px_rgba(235,188,120,0.22)] hover:-translate-y-0.5 hover:shadow-[0_16px_30px_rgba(235,188,120,0.28)]",
  secondary:
    "bg-brand-primary text-white shadow-[0_12px_24px_rgba(20,50,135,0.16)] hover:-translate-y-0.5 hover:bg-brand-secondary hover:shadow-[0_16px_30px_rgba(20,50,135,0.22)]",
  outline:
    "border border-brand-primary/20 bg-white text-brand-primary shadow-none hover:-translate-y-0.5 hover:bg-brand-primary/5",
  ghost: "bg-transparent text-brand-primary hover:bg-brand-primary/10",
  inline:
    "normal-case bg-transparent px-0 py-0 text-xs font-semibold tracking-normal text-brand-primary hover:bg-transparent hover:underline",
  icon:
    "border border-brand-primary/20 bg-white text-brand-primary shadow-none hover:-translate-y-0.5 hover:bg-brand-primary/5",
};

const radiusClasses = {
  xl: "rounded-xl",
  "2xl": "rounded-2xl",
  full: "rounded-full",
  lg: "rounded-lg",
  none: "rounded-none",
};

const sizeClasses = {
  sm: "px-4 py-2.5 text-sm",
  md: "px-5 py-3 text-sm",
  lg: "px-6 py-3.5 text-sm",
  xl: "px-6 py-3.5 text-sm",
  icon: "p-0",
};

const motionClasses = {
  lift: "transition-transform transition-shadow duration-200",
  subtle: "transition-colors duration-200",
  none: "transition-colors duration-200",
};

export function BrandButton({
  as: Component = "button",
  variant = "primary",
  radius = "xl",
  rounded = null,
  size = "xl",
  motion = "lift",
  className = "",
  type = "button",
  children,
  ...props
}) {
  const resolvedType = Component === "button" ? type : undefined;
  const resolvedSizeClass = variant === "inline" ? "" : sizeClasses[size];
  const resolvedRadius = rounded ?? radius;

  return (
    <Component
      type={resolvedType}
      className={[
        "inline-flex items-center justify-center gap-2 font-bold uppercase tracking-[0.12em] outline-none disabled:cursor-not-allowed disabled:opacity-70",
        radiusClasses[resolvedRadius],
        variantClasses[variant],
        resolvedSizeClass,
        motionClasses[motion],
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
